import React from 'react';
export function StatsBar() {
  const stats = ['Cotizaciones en visto', 'Una venta más por mes', 'Competir sin precio', 'Aplicable desde hoy'];
  return <section className="bg-gold text-navy py-10 px-5 border-y border-gold/20" data-id="element-169">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center" data-id="element-170">
        {stats.map((stat, index) => <div key={index} className="flex flex-col items-center justify-center p-2" data-id="element-171">
            <span className="font-playfair font-bold text-lg md:text-xl leading-tight" data-id="element-172">
              {stat}
            </span>
          </div>)}
      </div>
    </section>;
}